/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";
import { EventInfo } from "utility";
import type {
  EventVideo,
  Refference,
  Ticket,
} from "@spwn/types/firebase/firestore";
import { ResGetStreamingKey } from "../../../../../types/functions";
import { EventVideoTicket } from "components/event/detail/videoList/EventVideoTicket";

type Props = {
  videoTickets: (Ticket & Refference)[];
  displayEvent: EventInfo;
  eventVideoMap: {
    [videoId: string]: EventVideo;
  } | null;
  streamingKey: ResGetStreamingKey;
  handleButtonAction: (ticketId: string | undefined) => void;
  handleButtonActionWithVideoTicket: (videoTicket: Ticket & Refference) => void;
};
export const EventVideoTicketList: React.FC<Props> = (props) => {
  const {
    displayEvent,
    eventVideoMap,
    streamingKey,
    handleButtonAction,
    handleButtonActionWithVideoTicket,
    videoTickets,
  } = props;

  const classes = eventVideoTicketListDesign();

  return (
    <div css={classes.root}>
      {videoTickets.map((videoTicket, i) => {
        return (
          <EventVideoTicket
            key={i}
            {...{
              videoTicket,
              displayEvent,
              eventVideoMap,
              streamingKey,
              handleButtonAction,
              handleButtonActionWithVideoTicket,
            }}
          />
        );
      })}
    </div>
  );
};

const eventVideoTicketListDesign = () => {
  return {
    root: css`
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: start;
      &::after {
        @media screen and (min-width: 768px) {
          content: "";
          display: block;
          width: 31%;
        }
      }
    `,
  };
};
